import { oktaGet } from '../oktaRequestWrapper';
import { ApiRoutes } from '../apiRoutes';
import { useQuery } from 'react-query';
import { generatePath } from 'react-router-dom';
import {
  SearchInvoiceDocuments,
  SearchInvoiceDocumentsRequest,
} from '@/app/features/DebtorPortal/InvoiceDetail/invoiceDetail.types';

export const getInvoiceDocuments = (request: SearchInvoiceDocumentsRequest) =>
  useQuery({
    queryKey: [],
    enabled: false,
    queryFn: async (): Promise<SearchInvoiceDocuments[]> => {
      const route = generatePath(ApiRoutes.SearchInvoiceDocuments, {
        assetId: request.assetId.toString(),
      });
      const response = await oktaGet<SearchInvoiceDocuments[]>(route);
      return response.data;
    },
  });

export const getInvoiceDocumentsDownloadUrl = async (
  request: SearchInvoiceDocumentsRequest
): Promise<string> => {
  const route = generatePath(ApiRoutes.SearchInvoiceDocuments, {
    assetId: request.assetId.toString(),
  });
  const response = await oktaGet<string>(route, { params: { fileType: 'pdf' } });
  return response.data;
};
